module.exports = __webpack_public_path__ + "img/auto-riservate-white.c8276f2d.svg";